import * as React from 'react';
import { Wrapper } from '../basic';
import { Text } from './';
import { LoadingImage } from '..';
export class LocalizeLoading extends React.Component {
    render() {
        const { text, wrapper } = this.props;
        return (React.createElement(Wrapper, { element: wrapper },
            text || React.createElement(Text, { id: "loading" }),
            "... ",
            React.createElement(LoadingImage, null)));
    }
}
//# sourceMappingURL=Loading.js.map